import BlogArticlePage from '../components/BlogArticles';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Non-Verbal Communication Is the Robotics Unlock | Cartwheel',
  'Why believable non-verbal communication matters more than task completion for robots entering our lives.',
);

export default BlogArticlePage;
